import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async () => {
  return await httpRequest.get("/api/theme/tenants");
};

export const get = async (id: string) => {
  return await httpRequest.get(`/api/theme/tenants/${id}`);
};

export const create = async (data: { name: string; domain: string; adminEmail: string; phone: string }) => {
  return await httpRequest.post("/api/theme/tenants", data);
};

export const update = async (id: string, data: any) => {
  return await httpRequest.put(`/api/theme/tenants/${id}`, data);
};

export const remove = async (id: string) => {
  return await httpRequest.del(`/api/theme/tenants/${id}`);
};

export const saveTheme = async (id: string, data: any) => {
  return await httpRequest.put(`/api/theme/tenants/${id}/theme`, data);
};

export const previewTheme = async (id: string, data: any) => {
  return await httpRequest.post(`/api/theme/tenants/${id}/theme/preview`, data);
};

export const setLocalhost = async (id: string) => {
  return await httpRequest.put(`/api/theme/tenants/${id}/set-localhost`, {});
};

export const unsetLocalhost = async (id: string) => {
  return await httpRequest.put(`/api/theme/tenants/${id}/unset-localhost`, {});
};
